import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { bonuses, bonusValueRows } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-mist border-y border-mist-dark" data-id="element-16" data-mp="22ebqysm0mq8w">
      <div className="max-w-5xl mx-auto" data-id="element-17" data-mp="1ydrxbz0ni4ri">
        <div className="text-center mb-16" data-id="element-18" data-mp="1yet7m19uen86">
          <p className="text-azure font-bold tracking-widest uppercase mb-2" data-id="element-19" data-mp="1anxlnks2im8u">
            Included with the complete system — not sold separately
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy" data-id="element-20" data-mp="15n9la8hy8t1y">
            🎁 The <span className="text-gold-solid" data-id="element-21" data-mp="1ji27fpsch7hi">5 Professional</span> Bonuses
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-22" data-mp="1eorbijp2mb4d">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-mist-dark rounded-2xl p-8 relative shadow-sm flex flex-col ${index === bonuses.length - 1 && bonuses.length % 2 !== 0 ? 'md:col-span-2' : ''}`} data-id="element-23" data-mp="qyn4018rhr83" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-navy text-white px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-24" data-mp="2og7lykrce4v0">
                🎁 BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-gold/15 rounded-full flex items-center justify-center text-gold-dark mb-4" data-id="element-25" data-mp="1vstxlb1pmhmi">
                <Gift size={24} data-id="element-26" data-mp="20thm9q2gumdk" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-24 text-navy" data-id="element-27" data-mp="25qrippo9vyaw">
                {bonus.title}
              </h3>
              <p className="text-sm text-azure-dark font-medium mb-4 leading-snug" data-id="element-28" data-mp="3c61wgvo6vhc3">
                {bonus.headline}
              </p>
              <div className="self-start bg-mist px-3 py-1 rounded mb-4 border border-mist-dark" data-id="element-29" data-mp="1h3f19lwqd342">
                <span className="text-slate text-sm" data-id="element-30" data-mp="1c4au10td9fgd">
                  Real value: <span className="line-through text-alert" data-id="element-31" data-mp="1c42et29rty20">${bonus.value}</span>
                </span>
                <span className="text-gold-dark font-bold ml-2" data-id="element-32" data-mp="1q3agc1tepi9d">→ FREE</span>
              </div>
              <ul className="space-y-3 mb-6 flex-grow" data-id="element-33" data-mp="1m39qzm4rrmnj">
                {bonus.points.map(point => <li key={point} className="text-slate text-sm leading-relaxed" data-id="element-34" data-mp="yd5s1s2j0b2v">
                    {point}
                  </li>)}
              </ul>
              <p className="text-navy text-sm italic font-medium mt-auto" data-id="element-35" data-mp="1769724stkvzm">{bonus.benefit}</p>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border border-gold/40 rounded-2xl p-8 max-w-2xl mx-auto shadow-sm" data-id="element-36" data-mp="12co7w9fhpvyu">
          <h3 className="text-2xl font-serif font-bold text-navy text-center mb-6" data-id="element-37" data-mp="5amtf1n3dt9p">
            💰 Total Value of the 5 Bonuses
          </h3>
          <div className="overflow-hidden rounded-xl border border-mist-dark" data-id="element-38" data-mp="3msfq66km64sn">
            <table className="w-full text-left" data-id="element-39" data-mp="3rqh8uqe4o23l">
              <thead className="bg-navy text-white text-xs uppercase tracking-wider" data-id="element-40" data-mp="j9w6hsg0479g">
                <tr data-id="element-41" data-mp="j81ksbwwob4b">
                  <th scope="col" className="px-4 py-3 font-bold" data-id="element-42" data-mp="o8pb0vdb8nxh">
                    Bonus
                  </th>
                  <th scope="col" className="px-4 py-3 font-bold text-right" data-id="element-43" data-mp="9chqtv1wjmi7">
                    Value
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-44" data-mp="ecm6jiuzkd7d">
                {bonusValueRows.map(row => <tr key={row.label} className="border-t border-mist-dark" data-id="element-45" data-mp="2u0m8sbstjd9v">
                    <td className="px-4 py-3 text-sm text-slate" data-id="element-46" data-mp="2z1ti4fam0kin">{row.label}</td>
                    <td className="px-4 py-3 text-sm text-navy font-medium text-right" data-id="element-47" data-mp="3f8eswwlgusu7">
                      {row.value}
                    </td>
                  </tr>)}
                <tr className="border-t border-mist-dark bg-mist" data-id="element-48" data-mp="35htxfi13a4fi">
                  <td className="px-4 py-3 text-sm font-bold text-navy" data-id="element-49" data-mp="35g0p7yatvc5e">Total Bonus Value</td>
                  <td className="px-4 py-3 text-sm font-bold text-alert text-right line-through" data-id="element-50" data-mp="30h5y892piha7">
                    $119
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="text-center mt-6" data-id="element-51" data-mp="3o8ut9x6wxjuu">
            <p className="text-lg text-navy mb-2" data-id="element-52" data-mp="3o7jphxdgwc3q">Your Price Today</p>
            <p className="text-4xl font-bold text-gold-solid mb-4" data-id="element-53" data-mp="3ja9v03b81a91">🎁 ALL 5 BONUSES FREE</p>
            <p className="text-sm text-slate" data-id="element-54" data-mp="2ctfvir6vqnyo">Only included with this offer.</p>
          </div>
        </motion.div>

        <CountdownTimer data-id="element-55" data-mp="27uboo77fh2bi" />
      </div>
    </section>;
}